import React, { useState, useEffect } from 'react';
import { Modal } from 'zarm';
import { Toast } from '@iyunbao/components';
import classnames from 'classnames';
import { renderEngine, action as Action } from '@iyunbao/cr-engine';
import { deepCopy } from '../../utils/tools';

import { IProps } from './type';
import "./style/index.scss";

const PREFIXDATABIND = 'formTemplate';
const COMBINEMARK = '-';
function FormTemplate(props: IProps) {
  const { 
    prefixCls = 'form-template',
    className,
    onChange,
    onAddressBook,
    baseChildren = [], // [{widget:'', name: 'tt', dataBind: 'tt'}]
    option,
    defaultValue,
    _crengine,
  } = props;

  const [dataList, setDataList] = useState<any[]>([]); // [[children, isOpen]] 数组第一层表示列表个数，数组第二层表示子元素列表（children）
  const [dataBindKey, setDataBindKey] = useState<number>(0); // 用于设置dataBind前缀附加key，作为唯一标识

  const setPrefixForDataBind = (list, key) => {
    const copyList = deepCopy(list);

    copyList.map((i) => {
      const { dataBind, name, childrens } = i;
      const uniKey = dataBind || name;
      const prefix = `${PREFIXDATABIND}${COMBINEMARK}${key}${COMBINEMARK}${_crengine?.dataBind}${COMBINEMARK}`;
      i.dataBind = `${prefix}${uniKey}`;

      if (childrens?.length > 0) {
        setPrefixForDataBind(childrens, key);
      }
    });
    return copyList;
  };

  useEffect(() => {
    const tempValue = deepCopy(defaultValue) || [];
    const valueLength = tempValue.length;
    // 初始化设置多个item
    if (valueLength > 0) {
      const tempList: Array<any> = [];
      tempValue.forEach((i, k) => {
        const copyChildren = deepCopy(baseChildren);
        copyChildren.forEach((child) => {
          const { dataBind } = child;
          // dataBind: path.bind
          child.defaultValue = i[dataBind.split('.').pop()];
        });
        tempList.push({children: setPrefixForDataBind(copyChildren, k), isOpen: true});
      });
      setDataList(tempList);
      setDataBindKey(valueLength - 1);
    } else {
      // 初始化设置1个item
      setDataList([{children: setPrefixForDataBind(baseChildren, 0), isOpen: true}]);
    }
  }, [baseChildren, defaultValue]);

  // 部分按钮点击，触发onChange事件，以便重新试算。
  const handleChange = (actionType?: String) => {
    // 页面渲染完成后调用onChange事件，外层可拿到最新数据
    setTimeout(() => {
      const { onChange, ...changeRest } = props;

      if (onChange) {
        onChange({
          ...changeRest,
          actionType
        });
      }
    });
  };

  const deleteItem = (key, showTitle) => {
    Modal.confirm({
      title: '提示',
      content: `确认删除${showTitle}吗？`,
      onOk: () => {
        const tempList = deepCopy(dataList);
        tempList.splice(key, 1);
        setDataList(tempList);
        handleChange('deleteItem');
      },
    });
  };

  const toggleItem = (key) => {
    const tempList = deepCopy(dataList);
    tempList[key].isOpen = !tempList[key].isOpen;
    setDataList(tempList);
  };

  const renderPannel = (key, isOpen) => {
    const { title, subTitles, pannelCls} = option || {};
    const num = dataList.length > 1 ? key+1 : '';
    const showTitle = `${title}${num}`;
    const pannelClass = classnames('pannel', pannelCls);
    let subTitle = '';
    if (subTitles?.length) {
      // 如果subTitles[key]存在，说明是回显数据；否则默认不展示
      subTitle = subTitles[key] || '';
    }
    return (
      <div className={pannelClass}>
        <div className="pannel-desc">
          <span className="pannel-desc-title">{showTitle}</span>
          {!!subTitle && (
            <span className="pannel-desc-subTitle">{subTitle}</span>
          )}
        </div>
        {dataList.length > 1 && (
          <div className="pannel-handle">
            <img src="https://static.iyb.tm/web/h5/iyb-components-mobile/icon-delete.png" alt="" onClick={() => deleteItem(key, showTitle)} />
            <img src={`https://static.iyb.tm/web/h5/iyb-components-mobile/icon-${isOpen ? 'open' : 'fold'}.png`} alt="" onClick={() => toggleItem(key)} />
          </div>
        )}
      </div>
    );
  };

  const renderChildren = (children) => {
    const { components, form } = _crengine || {};
    const options = {
      components,
      form,
    };
    const wevents = {
      onChange,
      onAddressBook,
    };

    return renderEngine(children, options, wevents);
  };

  const handleAddBtn = () => {
    const { onChange, ...changeRest } = props;
    const { onActions } = _crengine || {};
    const { action } = option || {};
    const { type } = action || {};

    // 每添加一次，添加一个带默认值的模块
    const add = () => {
      const tempKey = dataBindKey + 1;
      setDataBindKey(tempKey);
      const tempList = deepCopy(dataList);
      tempList.push({children: setPrefixForDataBind(baseChildren, tempKey), isOpen: true});
      setDataList(tempList);
      handleChange('addBtn');
    };

    if (type && onActions[type]) {
      onActions[type](changeRest, action).then(({ result, content, reason }) => {
        if (result === 'success') {
          if (content === true) {
            add();
            return;
          }
          const { type, data } = content;
          type && Action[type](data);
        } else {
          Toast.warning(reason || '新增失败');
        }
      });
      return;
    }

    add();
  };

  const renderAddBtn = () => {
    const { addDesc, hidden } = option || {};

    if (hidden) {
      return null;
    }
    return (
      <div className="addBtn" onClick={handleAddBtn}>
        <img src="https://static.iyb.tm/web/h5/iyb-components-mobile/icon-add.png" alt="" />
        <span>{addDesc}</span>
      </div>
    );
  };

  const formatChildren = (children) => {
    return {
      "widget": "page",
      "childrens": children
    };
  };

  const cls = classnames(className, prefixCls);
  return (
    <div className={cls}>
      {dataList?.length > 0 && dataList.map((item, key) => {
        const {children, isOpen} = item;
        const childCls = classnames({[`${prefixCls}-hidden`]: !isOpen});
        return (
          <div key={key} className={`${prefixCls}-item${dataList.length - 1 === key ? '-last' : ''}`}>
            {renderPannel(key, isOpen)}
            <div className={childCls}>
              {renderChildren(formatChildren(children))}
            </div>
          </div>
        );
      })}
      {renderAddBtn()}
    </div>
  );
}

export default FormTemplate;
